export const ActionUpdateInterface = [
    'id',
    'deleted',
    'ownerId',
    'recordId',
    'description',
    'result',
    'rootCause',
    'actionTaken',
    'completedDate',
    'requestDate',
    'expectedCompleteDate',
    'owner',
];
